import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { FileSharingComponent } from './pages/file-sharing/file-sharing.component';
import { EntryLoginComponent } from './pages/entry-login/entry-login.component';

export const routes: Routes = [
  {
    path: '',
    component: EntryLoginComponent,
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  { path: 'file-sharing', component: FileSharingComponent },
  { path: '**', redirectTo: 'releases' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
